var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "pt-2": "" } },
    [
      _c(
        "v-flex",
        { attrs: { shrink: "", "pr-0": "" } },
        [
          _c("v-subheader", { staticClass: "pl-0" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "pr-3": "" } },
        [
          _c(
            "v-slider",
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  "thumb-label": "always",
                  step: "1",
                  ticks: "always",
                  "tick-size": "2",
                  "hide-details": "",
                },
                on: { input: (val) => _vm.$emit("input", val) },
              },
              "v-slider",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }